import React, { useCallback, useEffect, useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import api from '../api/api';

import { Image } from 'primereact/image';

import '../layout/sass/_form.scss';
import { SelectButton } from 'primereact/selectbutton';

export const FormPessoa = ({ isEditing, isLoading, defaultValues }) => {

    const history = useHistory();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [showSemDocs, setShowSemDocs] = useState(false);
    const [imagem, setImagem] = useState("");
    const [estilo, setEstilo] = useState({});
    const [solicitacoesLista, setSolicitacoesLista] = useState([]);
    const [atualizarCheckbox, setAtualizarCheckbox] = useState(Math.random());
    const [muda, setMuda] = useState([]);
    const [showMudas, setShowMudas] = useState(false);

    const getImagem = async () => {
        try {
            const response = await api.get(`pessoa/download/${formik.values.arquivo}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', formik.values.arquivo);

            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao baixar imagem!', detail: error.toString() });
        }
    };

    const schema = Yup.object().shape({
        nome: Yup
            .string()
            .required("O nome é obrigatório")
            .max(200, "O nome deve ter no máximo 200 caracteres"),
        cpf: Yup
            .string()
            .required("O CPF é obrigatório"),
        email: Yup
            .string()
            .email("Informe um e-mail válido")
            .nullable(),
        numero_instalacao: Yup
            .string()
            .required("O Nº da instalação é obrigatório"),
    });

    const formik = useFormik({
        initialValues: defaultValues,
        validationSchema: schema,
        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true);

            try {
                if (!isEditing) {
                    await api.post("pessoa", data);
                    formik.resetForm();
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.nome} adicionado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/pessoa');
                    }, 2000);
                } else {
                    await api.put("pessoa", data);
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.nome} atualizado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/pessoa');
                    }, 2000);
                }
            } catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar pessoa!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar pessoa!', detail: error.toString() });
            }

            setIsSubmiting(false);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    useEffect(() => {
        const fetchImagem = async () => {
            try {
                if (formik.values.arquivo) {
                    const response = await api.get(`pessoa/download/${formik.values.arquivo}`, {
                        responseType: 'blob',
                    });

                    const blob = new Blob([response.data], { type: 'image/*' });
                    const url = URL.createObjectURL(blob);
                    setImagem(url);
                    setEstilo({});
                } else {
                    setEstilo({ display: 'none' });
                }
            } catch (error) {
                toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao buscar imagem!', detail: error.toString() });
            }
        };

        fetchImagem();
    }, [formik.values.arquivo]);

    const getEntregue = useCallback(async (pessoaId, campanhaId) => {
        try {
            let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoaId}/${campanhaId}`);
            return entregue.data === true;
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao buscar solicitações', detail: error.toString() });
            return false;
        }
    }, []);

    const handleEntregueChange = async (pessoaId, campanhaId, entregue) => {
        let pessoaMudas = await api.get(`/pessoaMudas/solicitacao/${pessoaId}/${campanhaId}`);
        for (const pessoaMuda of pessoaMudas.data) {
            let tempPessoaMuda = {
                "id": pessoaMuda.id,
                "quantidade": pessoaMuda.quantidade,
                "pessoaId": pessoaMuda.pessoaId,
                "campanhaMudaId": pessoaMuda.campanhaMudaId,
                "campanhaId": pessoaMuda.campanhaId,
                "mudaEntregue": !entregue,
            };
            await api.put("pessoaMudas", tempPessoaMuda);
        }
        setAtualizarCheckbox(Math.random());
    };

    const getMudas = async (pessoaId, campanhaId) => {
        let pessoaMudas = await api.get(`/pessoaMudas/solicitacao/${pessoaId}/${campanhaId}`);
        setMuda(pessoaMudas.data.map((item) => (
            <tr key={item.id}>
                <td><span>{item.campanhaMudaMudaNome}</span></td>
                <td><span>{item.quantidade}</span></td>
            </tr>
        )));
        setShowMudas(true);
    };

    const getSolicitacoes = useCallback(async () => {
        try {
            if (isEditing && defaultValues && defaultValues.id && defaultValues.campanhaMudas) {
                let idsCampanha = defaultValues.campanhaMudas.map(item => item.campanhaId);
                const idsCampanhaFiltrado = idsCampanha.filter((value, index, self) => self.indexOf(value) === index);

                const dados = await Promise.all(
                    idsCampanhaFiltrado.map(async (campanhaId) => {
                        let entregue = await getEntregue(defaultValues.id, campanhaId);
                        return { campanhaId, entregue };
                    })
                );

                setSolicitacoesLista(dados);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao buscar solicitações', detail: error.toString() });
        }
    }, [isEditing, defaultValues, getEntregue]);

    useEffect(() => {
        if (isEditing && defaultValues?.id) {
            getSolicitacoes();
        }
    }, [defaultValues?.id, atualizarCheckbox, getSolicitacoes, isEditing]);

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            
            <Dialog
                visible={showSemDocs}
                onHide={() => setShowSemDocs(false)} 
                breakpoints={{ '960px': '75vw', '640px': '100vw' }} 
                style={{ width: '50vw', heigth: '5vw' }}
            >
                <div style={{ display: 'flex', justifyContent: 'center' }} className="p-field">
                    <label style={{ fontWeight: 'bold', fontSize: '20px' }}>
                        Não há documentos Anexados!
                    </label>

                    {formik.errors.tipo && formik.touched.tipo &&
                        <ErrorValidationMessage message={formik.errors.tipo} />
                    }
                </div>
            </Dialog>

            <Dialog
                visible={showMudas}
                onHide={() => setShowMudas(false)}
                className='p-scrollpanel-bar-y'
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                style={{ width: '20vw', heigth: '5vw' }}
            >
                <div id="print-content">
                    <div className="p-d-flex p-ai-center p-flex-column header">
                        <h2>Mudas Solicitadas</h2>
                    </div>
                    <table width="100%" border="1" style={{ borderCollapse: 'collapse' }} cellPadding={3} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th><i>Muda</i></th>
                                <th><i>Quantidade</i></th>
                            </tr>
                        </thead>

                        <tbody>
                            {muda}
                        </tbody>
                    </table>
                </div>
            </Dialog>

            <div className="p-col-12">
                <h2 className="p-mt-0">Pessoas</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="nome"
                                className={classNames({ 'p-error': isFormFieldValid('nome') })}
                            >
                                Nome
                            </label>
                            {!isLoading ? (
                                <InputText
                                    id="nome"
                                    name="nome"
                                    className={classNames({ 'p-invalid': isFormFieldValid('nome') })}
                                    value={formik.values.nome || ''}
                                    onChange={formik.handleChange}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.nome && formik.touched.nome &&
                                <ErrorValidationMessage message={formik.errors.nome} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="cpf"
                                className={classNames({ 'p-error': isFormFieldValid('cpf') })}
                            >
                                CPF
                            </label>
                            {!isLoading ? (
                                <InputMask
                                    id="cpf"
                                    name="cpf"
                                    mask="999.999.999-99"
                                    unmask={true}
                                    value={formik.values.cpf || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('cpf') })}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.cpf && formik.touched.cpf &&
                                <ErrorValidationMessage message={formik.errors.cpf} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="email"
                                className={classNames({ 'p-error': isFormFieldValid('email') })}
                            >
                                E-mail
                            </label>
                            {!isLoading ? (
                                <InputText
                                    id="email"
                                    name="email"
                                    type="email"
                                    className={classNames({ 'p-invalid': isFormFieldValid('email') })}
                                    value={formik.values.email || ''}
                                    onChange={formik.handleChange}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.email && formik.touched.email &&
                                <ErrorValidationMessage message={formik.errors.email} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="numero_instalacao"
                                className={classNames({ 'p-error': isFormFieldValid('numero_instalacao') })}
                            >
                                Nº da Instalacao
                            </label>
                            {!isLoading ? (
                                <InputMask
                                    id="numero_instalacao"
                                    name="numero_instalacao"
                                    mask="9999999999"
                                    unmask={true}
                                    value={formik.values.numero_instalacao || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('numero_instalacao') })}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.numero_instalacao && formik.touched.numero_instalacao &&
                                <ErrorValidationMessage message={formik.errors.numero_instalacao} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="rural"
                                className={classNames({ 'p-error': isFormFieldValid('rural') })}
                            >
                                Zona
                            </label>
                            {!isLoading ? (
                                <InputText
                                    id="rural"
                                    name="rural"
                                    className={classNames({ 'p-invalid': isFormFieldValid('rural') })}
                                    value={formik.values.rural === true ? 'Rural' : 'Urbana'}
                                    onChange={formik.handleChange}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.rural && formik.touched.rural &&
                                <ErrorValidationMessage message={formik.errors.rural} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="endereco_ou_fazenda"
                                className={classNames({ 'p-error': isFormFieldValid('endereco_ou_fazenda') })}
                            >
                                Endereço ou Fazenda
                            </label>
                            {!isLoading ? (
                                <InputText
                                    id="endereco_ou_fazenda"
                                    name="endereco_ou_fazenda"
                                    className={classNames({ 'p-invalid': isFormFieldValid('endereco_ou_fazenda') })}
                                    value={formik.values.endereco_ou_fazenda || ''}
                                    onChange={formik.handleChange}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.endereco_ou_fazenda && formik.touched.endereco_ou_fazenda &&
                                <ErrorValidationMessage message={formik.errors.endereco_ou_fazenda} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="bairro_ou_distrito"
                                className={classNames({ 'p-error': isFormFieldValid('bairro_ou_distrito') })}
                            >
                                Bairro ou Distrito
                            </label>
                            {!isLoading ? (
                                <InputText
                                    id="bairro_ou_distrito"
                                    name="bairro_ou_distrito"
                                    className={classNames({ 'p-invalid': isFormFieldValid('bairro_ou_distrito') })}
                                    value={formik.values.bairro_ou_distrito || ''}
                                    onChange={formik.handleChange}
                                    style={{ color: '#000' }}
                                    disabled
                                />
                            ) : (
                                <Skeleton height="35px" />
                            )}
                            {formik.errors.bairro_ou_distrito && formik.touched.bairro_ou_distrito &&
                                <ErrorValidationMessage message={formik.errors.bairro_ou_distrito} />
                            }
                        </div>

                        <div className="p-field p-col-6 p-sm-4">
                            <label
                                htmlFor="tipo"
                                className={classNames({ 'p-error': isFormFieldValid('tipo') })}
                                style={{ textAlign: 'justify', textJustify: 'distribute' }}
                            >
                                Fazer download do arquivo
                            </label>

                            <Button
                                label="Download"
                                type='button'
                                onClick={getImagem}
                                iconPos="right"
                                disabled={!formik.values.numero_instalacao}
                            />

                            {formik.errors.tipo && formik.touched.tipo &&
                                <ErrorValidationMessage message={formik.errors.tipo} />
                            }

                            <div style={estilo}>
                                <Image src={imagem} zoomSrc={imagem} preview alt="Não foi possível carregar a imagem" />
                            </div>
                        </div>

                        <div className="p-field p-col-12 p-sm-8">
                            {solicitacoesLista.map((item, index) => (
                                <div className="p-field p-col-12 p-sm-6 p-md-6" key={index}>
                                    <label htmlFor={`mudaEntregue_${item.campanhaId}`}>
                                        Mudas da Campanha {item.campanhaId}
                                    </label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <SelectButton
                                            id={`mudaEntregue_${item.campanhaId}`}
                                            name={`mudaEntregue_${item.campanhaId}`}
                                            value={item.entregue ? 'ENTREGUE' : 'NÃO ENTREGUE'}
                                            options={['ENTREGUE', 'NÃO ENTREGUE']}
                                            onChange={() => handleEntregueChange(defaultValues.id, item.campanhaId, item.entregue)}
                                            className="p-ml-1"
                                        />

                                        <Button
                                            label="Visualizar Mudas"
                                            type="button"
                                            onClick={() => getMudas(defaultValues.id, item.campanhaId)}
                                            iconPos="right"
                                            style={{ marginLeft: '10px' }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </form>
            </div>
        </div>
    );
};